<template>
<div>
    <!-- CSS Global Compulsory -->
    <link rel="stylesheet" href="../../static/assets/bootstrap/css/bootstrap.min.css">
    <link rel="stylesheet" href="../../static/assets/css/style.css">

    <!-- CSS Header and Footer -->
    <link rel="stylesheet" href="../../static/assets/css/header.css">
    <link rel="stylesheet" href="../../static/assets/css/footer.css">
    <div>
      <router-link to="/"><img style="position: absolute;z-index:2;left: 4%;top: 2%;height: 55px;" src="../../static/assets/img/headerlogo.png"/></router-link>
        <img src="../../static/assets/img/partnerheader.png" alt="" width="100%">
    </div>
    <div class="container content">
         <!-- Begin Content -->
        <div class="col-md-20">
            <div class="panel panel-red">
                <div class="panel-heading">
                    <div style="font-size: 25px;color:white">招募范围</div>
                    <p style="font-size: 15px;color:white">Recruitment scope</p>
                </div>
                <div class="panel-body">
                    <p style="font-size: 20px;color:black">全国范围内每个城市招募一位合伙人：武汉(总部)、北京、上海、广州、深圳、天津、重庆、南京、西安、成都、杭州除上述城市外全国其他城市均在招募范围！</p>
                </div>
            </div>
            <div class="panel panel-blue">
                <div class="panel-heading">
                    <div style="font-size: 25px;color:white">加盟要求</div>
                    <p style="font-size: 15px;color:white">Join requirements</p>
                </div>
                <div class="panel-body">
                    <p style="font-size: 20px;color:black">1：年龄在18到45周岁。</p>
                    <p style="font-size: 20px;color:black">2：对移动互联网有基本的认知和了解，使用并熟悉塔兮App各个功能。</p>
                    <p style="font-size: 20px;color:black">3：本人对生活有追求、有梦想、且自身沟通能力、社交能力比较强。</p>
                </div>
            </div>
            <div class="panel panel-sea">
                <div class="panel-heading">
                    <div style="font-size: 25px;color:white">加盟权益</div>
                    <p style="font-size: 15px;color:white">Franchise benefits</p>
                </div>
                <div class="panel-body">
                    <p style="font-size: 20px;color:black">1：合伙人将获得塔兮公司原始股。</p>
                    <p style="font-size: 20px;color:black">2：合伙人所在城市的塔兮的广告、招商、资讯服务等合作收入的78%归合伙人拥有。</p>
                    <p style="font-size: 20px;color:black">3：获得塔兮在当地城市的平台及衍生物等特许授权。</p>
                </div>
            </div>
            <div class="panel panel-green">
                <div class="panel-heading">
                    <div style="font-size: 25px;color:white">合伙人义务</div>
                    <p style="font-size: 15px;color:white">Partner obligations</p>
                </div>
                <div class="panel-body">
                    <p style="font-size: 20px;color:black">1：对塔兮App在所在城市进行推广。</p>
                    <p style="font-size: 20px;color:black">2：合伙人在指定时间内完成推广任务，总公司会根据所在城市大小制定合伙人需要推广的注册用户数量标准。</p>
                    <p style="font-size: 18px;color:grey">*注：合伙人在本地利用自己的人脉资源推广的注册用户和总公司宣传推广而产生的该城市自然增长的注册用户都属于本城市合伙人业绩</p>
                </div>
            </div>
            <div class="panel panel-orange">
                <div class="panel-heading">
                    <div style="font-size: 25px;color:white">联系我们</div>
                    <p style="font-size: 15px;color:white">Contact us</p>
                </div>
                <div class="panel-body">
                    <p style="font-size: 20px;color:black">商务合作联系人：曾先生</p>
                    <p style="font-size: 20px;color:black">QQ:239755888</p>
                    <p style="font-size: 20px;color:black">邮箱:towerx@towerxi.cn</p>
                </div>
            </div>
        </div>
    </div>


    <div class="footer-v1">
        <div class="footer">
            <div class="container">
                <div class="row">
                    <!-- About -->
                    <div class="col-md-2">
                      <img class="img-responsive " src="../../static/assets/img/txzmtm.png" alt="">
                    </div><!--/col-md-3-->
                    <!-- End About -->
                    <!-- Latest -->
                    <div class="col-md-4 md-margin-bottom-40">
                        <div class="posts">
                            <div class="headline"><h2>备案信息</h2></div>
                            <ul class="list-unstyled latest-list">
                                 <li>
                                  <a href="../../static/privacy.html" style="color: rgb(38, 104, 233);">隐私协议</a>
                                </li>
                                <li>
                                  <a href="../../static/protocol.html" style="color: rgb(38, 104, 233);">用户服务协议</a>
                                </li>
                                <li>
                                  <a href="../../static/tort.html" style="color: rgb(38, 104, 233);">侵权投诉指引</a>
                                </li>
                                <li style="color:white">
                                  <a href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备 18014986号-1</a><br>2019 &copy; 武汉云上塔兮信息技术有限公司 版权所有

                                </li>
                            </ul>
                        </div>
                    </div><!--/col-md-3-->
                    <!-- End Latest -->

                    <!-- Address -->
                    <div class="col-md-4 map-img ">
                        <div class="headline"><h2>联系我们</h2></div>
                        <address class="md-margin-bottom-40">
                            地址：湖北省武汉市洪山区珞喻路618号东方怡景大厦B座<br>
                            电话：027-88515977<br>
                            Email: <a href="mailto:towerx@towerxi.cn" style="color:rgb(38, 104, 233); ">towerx@towerxi.cn</a>
                        </address>
                    </div><!--/col-md-3-->
                    <!-- End Address -->
                </div>
            </div>
        </div><!--/footer-->


    </div>

</div>
</template>

<script>
export default {
    name:'Partner'
}
</script>



// WEBPACK FOOTER //
// src/views/Partner.vue